const themeClassNames = (theme) => {
    if (theme === 'dark') {
        return `theme--${theme}`;
    }
    return '';
};
export { themeClassNames };
